import React, {useContext, useState} from 'react';
import {NoteBookReportContext} from "./NoteBookReportContext";
import objectDataHolder from "../../Hooks/ObjectDataHolder";

import Section2NoteBookReport from "./Section2NoteBookReport";
import {fetchData} from "./functions";
import "./style.scss"

function MainSection(props) {
  const helper = useContext(NoteBookReportContext);
  const setData = helper.setData
  const data = helper.data

  const [show, setShow] = useState("section1"); // section2
  const [checkHolder, setCheckHolder] = objectDataHolder({
    group: false, kol: false, moien: false, tafsil: false,
  });
  const handleCheckHolder = (e, myKey) => {

    const isChecked = e.target.checked
    setCheckHolder({[myKey]: isChecked})

    const nazir = {group: 0, kol: 1, moien: 2, tafsil: 3,}

    let newLevel = data.level

    if (isChecked) {
      if (!data.level.includes(nazir[myKey])) {
        newLevel.push((nazir[myKey]))
      }
    } else {
      newLevel = newLevel.filter(item => item !== nazir[myKey])
    }

    setData({level: newLevel})

  }


  const clickHandler = () => {
    // میشه چک کرد اگه  هیچ تیکی نزده بود کلا درخواست نزنه ولی اینو دارم با بک هندل میکنم
    fetchData({data, setData}).then((res) => {
      if (res !== false) {
        setShow("section2")
      } else {
      }
    })
  }

  try {
    return (<div className={"font__size__10 mt-3 note__book__main"}>
      {show === "section1" && <>
        <div style={{width: 400, height: "60vh"}}>
          <div
            className={"text-center p-2"}
            style={{background: "#F1F1F1", borderRadius: 5}}
          >اولویت بندی حساب ها
          </div>
          <div className={"d-flex mt-1 little__table"}>
            <div style={{width: "50%"}}>
              <div className={" fw-bold text-center p-2   bg__color__F1F1F1 border__bottom"}
              >عنوان
              </div>
              {/*className={"d-flex justify-content-center align-items-center"}*/}
              <div className={"p-2"}>
                <div><input id={"group"} onChange={e => handleCheckHolder(e, "group")} type="checkbox"
                            checked={checkHolder.group}
                /> <label
                  htmlFor="group">گروه</label></div>
                <div><input id={"kol"} onChange={e => handleCheckHolder(e, "kol")} type="checkbox"
                            checked={checkHolder.kol}/> <label
                  htmlFor="kol">کل</label></div>
                <div><input id={"moien"} onChange={e => handleCheckHolder(e, "moien")} type="checkbox"
                            checked={checkHolder.moien}/> <label
                  htmlFor="moien">معین</label></div>
                <div><input id={"tafsil"} onChange={e => handleCheckHolder(e, "tafsil")} type="checkbox"
                            checked={checkHolder.tafsil}/>
                  <label htmlFor="tafsil">تفصیل</label></div>
              </div>
            </div>
            <div style={{width: "50%"}}>
              <div className={"text-center fw-bold p-2 bg__color__F1F1F1 border__bottom"}>عنوان</div>
              <div className={"pt-2 px-3"}>
                {data.level.sort().map((row, index) => {
                  const nazir = {0: "گروه", 1: "کل", 2: "معین", 3: "تفصیل"}
                  return <div key={index}>{nazir[row]}</div>
                })}
              </div>
            </div>

          </div>

        </div>
        <div className={"mt-0"}>
          <button
            className={"btn btn__secondary_purple wh104x28font14 p-0 m-2 my-5"}
            onClick={clickHandler}
          >
            فیلتر ثانویه
          </button>

        </div>
      </>}
      {show === "section2" && <Section2NoteBookReport setShow={setShow}/>}
    </div>);
  } catch (error) {
    return <div>{error.toString()}</div>
  }
}

export default MainSection;